var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "bid-now",
        },
        [
          _c(
            "div",
            { staticClass: "spaceCenter bid-title" },
            [
              _c("svg-icon", {
                staticClass: "icon",
                attrs: { "aria-hidden": "true", "icon-class": "trn-jingbiao" },
              }),
              _vm._v(" "),
              _c("div", [_vm._v("Bid Now")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "unit-input" },
            [
              _c("div", { staticClass: "spaceBetween" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "word-sm" },
                  [
                    _vm._v("\n          Balance :\n          "),
                    _c("big-number", {
                      attrs: { number: _vm.balance },
                      on: {
                        "update:number": function ($event) {
                          _vm.balance = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spaceBetween exchange-item" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { flex: "1 0 0" } },
                  [
                    _c("el-input", {
                      staticClass: "exchange-input",
                      attrs: { placeholder: "0.00" },
                      on: { change: _vm.checkNumber },
                      model: {
                        value: _vm.bidNum,
                        callback: function ($$v) {
                          _vm.bidNum = $$v
                        },
                        expression: "bidNum",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-right word-sm-num" }, [
                      _vm._v("$ " + _vm._s(_vm.changeMoney)),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("P", { staticClass: "des" }, [_vm._v("Minimum bid 1 Rep")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "checkLoginBtn" },
            [
              _c(
                "div",
                {
                  staticClass: "spaceBetween",
                  staticStyle: {
                    "margin-top": "0.7rem",
                    "margin-bottom": "0.13rem",
                  },
                },
                [
                  _c("span", { staticClass: "word-sm" }, [
                    _vm._v("Current cumulative bid"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "word-sm-num" },
                      [
                        _c("big-number", {
                          attrs: { number: _vm.currentcumulativebid },
                          on: {
                            "update:number": function ($event) {
                              _vm.currentcumulativebid = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "word-sm" }, [_vm._v("Rep")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("check-login-btn", {
                attrs: {
                  disabled: _vm.submitBtnText != "Submit" || +_vm.bidNum <= 0,
                  label: _vm.submitBtnText,
                },
                on: {
                  clickHandle: _vm.submit,
                  "update:label": function ($event) {
                    _vm.submitBtnText = $event
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("detail-btn", {
        staticStyle: { margin: "0.88rem 0 0 0" },
        attrs: { label: "View History" },
        on: { clickHandle: _vm.setShowDetail },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "word-sm" }, [
      _c("img", {
        staticStyle: { width: "0.16rem" },
        attrs: { src: require("@/assets/image/exchange/jiantou.svg") },
      }),
      _vm._v("\n          1 Rep = $ 0.8\n        "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spaceLeft unit-icon" }, [
      _c("img", {
        staticStyle: { width: "0.36rem", "margin-right": "0.08rem" },
        attrs: { src: require("@/assets/image/exchange/tat.png") },
      }),
      _vm._v("Rep\n          "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }